export default __webpack_public_path__ + "static/media/thumb_2_uwo.45d71e4a.png";